module.exports = __webpack_public_path__ + "static/media/eurodrive-col-1.4c8bc759.png";